/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_UNALLOACTED_BALANCE =
  'GET_REBATE_PROGRAM_UNALLOACTED_BALANCE';
export const SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY =
  'SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY';

export const GET_INSTITUTIONAL_CLAIMS_DISCREPANCY_SEARCH_RESULT =
  'GET_INSTITUTIONAL_CLAIMS_DISCREPANCY_SEARCH_RESULT';

export const GET_REFERENCE_DATA_INSTITUTIONAL_CLAIMS =
  'GET_REFERENCE_DATA_INSTITUTIONAL_CLAIMS';
export const REFRESH_INSTITUTIONAL_UNIT_TYPE_DISCREPANCY =
  'REFRESH_INSTITUTIONAL_UNIT_TYPE_DISCREPANCY';
export const IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY =
  'IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY';
